<template>
  <div class="animated fadeIn all-images">
    <vLoading v-if="vLoading" />
    <div v-if="$router.currentRoute.path == '/' + role + '/images'">
      <v-card class="common-card card-height">
        <v-row>
          <v-col class="pb-0">
            <h4 class="fs-xxlarge c-dark pt-2">مدیریت تصاویر</h4>
          </v-col>
          <v-col md="7" sm="8" cols="12" class="pb-0">
            <div class="d-flex flex-row float-end">
              <v-text-field
                v-if="deviceType == 'desktop'"
                rounded
                filled
                class="search-box mt-2 mt-sm-0"
                placeholder="جستجو در عناوین تصاویر..."
                v-model="filter"
              >
                <template v-slot:prepend-inner>
                  <v-icon class="ps-3">$searchIcon</v-icon>
                </template>
              </v-text-field>
              <v-btn
                :to="'/' + role + '/dashboard'"
                class="bc-purple btn-radius no-underline ms-5 me-0 mt-1"
                height="40"
                width="100"
                elevation="0"
              >
                <span class="fs-medium white--text">خانه</span>
              </v-btn>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="deviceType == 'mobile'">
          <v-col>
            <v-text-field
              rounded
              filled
              class="search-box mt-2 mt-sm-0"
              placeholder="جستجو در عناوین تصاویر..."
              v-model="filter"
            >
              <template v-slot:prepend-inner>
                <v-icon class="ps-3">$searchIcon</v-icon>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
        <v-row class="mt-5">
          <v-col class="pb-0">
            <h4 class="fs-xlarge c-dark pt-2 ms-4">گالری تصاویر</h4>
          </v-col>
          <v-col cols="5" class="text-left">
            <v-btn
              height="40"
              width="100"
              elevation="0"
              class="bc-white btn-border btn-radius"
              @click="addImageDialog = true"
            >
              <span class="fs-medium c-purple">افزودن</span>
            </v-btn>
          </v-col>
        </v-row>
        <v-row v-if="loaded" class="mt-0">
          <v-col v-if="!computedImage.length">
            <div class="no-content">
              <hr />
              موردی برای نمایش وجود ندارد.
              <hr />
            </div>
          </v-col>
          <v-col
            md="4"
            sm="6"
            cols="12"
            v-else
            v-for="(item, index) in computedImage"
            :key="index"
          >
            <div class="px-lg-4 px-0">
              <div class="image-box">
                <v-img :src="item.url"></v-img>
                <div
                  class="image-title fs-medium d-flex flex-row"
                  style="z-index: 100"
                >
                  <div>
                    {{
                      item.title.length > 25
                        ? item.title.slice(0, 25) + "..."
                        : item.title
                    }}
                  </div>
                  <v-spacer></v-spacer>
                  <div @click="openModal(item, 'edit')" class="pe-5">
                    <v-icon
                      class="img-icons"
                      style="transform: translateY(-1px)"
                      >$Edit</v-icon
                    >
                  </div>
                  <div @click="openModal(item, 'delete')">
                    <v-icon class="img-icons">$Trash</v-icon>
                  </div>
                </div>
                <div class="hover-box" @click="showBig(item)">
                  <div>
                    <v-icon>$zoomIcon</v-icon>
                    <p class="fs-large white--text mt-2 mb-0">مشاهده</p>
                  </div>
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-card>
      <v-dialog v-model="showImage" max-width="590">
        <v-card class="modal-card">
          <v-container class="text-center">
            <div class="image-box">
              <img :src="selected.url" />
            </div>
            <div class="px-1 mt-4 fs-medium text-right">
              {{ selected.title }}
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="editTitleDialog" width="600">
        <v-card class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xxlarge">ویرایش عنوان تصویر</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="editTitleDialog = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div class="textField-box mt-2">
              <v-text-field
                placeholder="عنوان تصویر"
                v-model="selectedImage.title"
                outlined
                rounded
              >
              </v-text-field>
            </div>
            <div>
              <v-btn
                class="bc-purple c-light"
                width="100"
                height="42"
                :disabled="!selectedImage.title"
                @click="editTitle()"
                >تایید</v-btn
              >
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="deleteImageDialog" width="600">
        <v-card class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xxlarge">حذف تصویر</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="deleteImageDialog = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div class="gallery-imageBox text-center">
              <img :src="selectedImage.url" />
            </div>
            <div class="text-center my-5">
              <span class="c-dark fs-medium font-weight-bold"
                >آیا از حذف تصویر اطمینان دارید؟</span
              >
            </div>
            <div class="text-center pt-3">
              <v-btn
                class="btn-border bc-white c-purple mx-2"
                width="100"
                height="42"
                elevation="0"
                @click="deleteImageDialog = false"
                >لغو</v-btn
              >
              <v-btn
                class="bc-purple c-light mx-2"
                width="100"
                height="42"
                @click="deleteImage()"
                >تایید</v-btn
              >
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-dialog v-model="addImageDialog" width="450">
        <v-card class="modal-card">
          <v-container class="p-4">
            <v-row class="mb-1">
              <v-col class="text-right">
                <h5 class="mt-1 c-dark fs-xlarge">افزودن تصویر</h5>
              </v-col>
              <v-col cols="2" class="text-left">
                <span @click="addImageDialog = false">
                  <v-icon class="pointer">$Close</v-icon>
                </span>
              </v-col>
            </v-row>
            <div v-if="!uploading">
              <div class="textField-box2 pt-4 d-flex flex-row">
                <span class="pe-4 ps-0 pt-3 c-dark fs-medium">عنوان عکس: </span>
                <div>
                  <v-text-field
                    placeholder="عنوان"
                    rounded
                    outlined
                    class="w-100"
                    v-model="title"
                  ></v-text-field>
                </div>
              </div>
              <hr />
              <div
                class="upload-box"
                :class="!title ? 'disabled' : ''"
                @dragover="dragover"
                @dragleave="dragleave"
                @drop="drop"
              >
                <p class="c-grey fs-large mb-2 mt-1">
                  {{
                    title
                      ? "فایل مورد نظر را به این قسمت بکشید"
                      : "ابتدا عنوان تصویر را وارد نمایید."
                  }}
                </p>
                <p v-if="title" class="c-grey fs-large mb-2">یا</p>
                <v-btn
                  v-if="title"
                  @click="$refs.upload.$refs.input.click()"
                  class="upload-btn"
                  height="42"
                  >یافتن فایل</v-btn
                >
              </div>
            </div>
            <div v-else>
              <div class="d-flex flex-row w-100">
                <div>
                  <v-icon class="mt-2" large>$File</v-icon>
                </div>
                <div class="w-100 px-3">
                  <p class="mb-0">در حال بارگذاری تصویر...</p>
                  <v-progress-linear
                    class="mt-1"
                    outlined
                    height="4"
                    :value="myFile.uploadPercentage"
                    color="#93329e"
                  >
                  </v-progress-linear>
                </div>
                <div class="c-purple pt-4 px-1">
                  {{ myFile.uploadPercentage }}%
                </div>
              </div>
            </div>
          </v-container>
        </v-card>
      </v-dialog>
      <v-file-input
        @change="myUpload(file)"
        v-model="file"
        ref="upload"
        outlined
        dense
        v-show="false"
      ></v-file-input>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploadedFiles: [],
      uploadPercentage: 0,
      isUploaded: false,
      file: [],
      myFile: new Object({
        uploadPercentage: 0,
      }),
      images: [],
      loaded: false,
      filter: "",
      selected: {},
      showImage: false,
      vLoading: false,
      editTitleDialog: false,
      deleteImageDialog: false,
      addImageDialog: false,
      selectedImage: {},
      deviceType: "",
      role: "",
      uploading: false,
      title: "",
    };
  },
  methods: {
    openModal(item, type) {
      this.selectedImage = JSON.parse(JSON.stringify(item));
      if (type == "edit") {
        this.editTitleDialog = true;
      }
      if (type == "delete") {
        this.deleteImageDialog = true;
      }
    },
    editTitle() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/" + this.role + "/profile/editGallery",
          {
            fileId: this.selectedImage.id,
            title: this.selectedImage.title,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.editTitleDialog = false;
          this.toast(res.data, "success");
          this.getImages();
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    deleteImage() {
      this.vLoading = true;
      this.$http
        .post(
          this.baseUrl + "/setad/" + this.role + "/profile/removeGallery",
          {
            fileId: this.selectedImage.id,
          },
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.deleteImageDialog = false;
          this.toast(res.data, "success");
          this.getImages();
        })
        .catch((err) => {
          this.vLoading = false;
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
        });
    },
    getImages() {
      this.vLoading = true;
      this.loaded = false;
      this.$http
        .post(
          this.baseUrl + "/setad/" + this.role + "/profile/gallery",
          {},
          {
            headers: {
              Authorization: "Bearer: " + localStorage.getItem("userId"),
            },
          }
        )
        .then((res) => {
          this.images = res.data;
          this.loaded = true;
          this.vLoading = false;
        })
        .catch((err) => {
          if (err.response.status == 403)
            // this.$router.replace("/unauthorize");
            this.$router.push({
              path: "/login",
              query: { return: window.location.pathname },
            });
          this.vLoading = false;
        });
    },
    myUpload(file) {
      if (!file) {
        return;
      }
      let sizeMB = file.size / 1024 / 1024;

      if (sizeMB > 5) {
        this.toast(
          "حجم فایل " + file.name + " نباید از 5 مگابایت بیشتر باشد",
          "error"
        );
        return;
      } else if (file.type != "image/jpeg" && file.type != "image/png") {
        this.toast("فرمت فایل مورد نظر مجاز نمی‌باشد.", "error");
        return;
      } else {
        //CHECK FILE SIZE
        this.uploading = true;

        // START UPLOAD PROCESS
        this.myFile.showProgress = true;
        this.myFile.variant = "info";
        this.myFile.uploadPercentage = 0;
        this.myFile.isUploaded = false;
        this.myFile.uploadButDisable = true;
        var formData = new FormData();
        formData.append(file.name, file);
        this.$http
          .post(
            this.baseUrl +
              "/setad/" +
              this.role +
              "/profile/addGallery?title=" +
              this.title,
            formData,
            {
              headers: {
                Authorization: "Bearer: " + localStorage.getItem("userId"),
              },
              onUploadProgress: ((progressEvent) => {
                this.myFile.uploadPercentage =
                  Math.round(
                    (progressEvent.loaded * 100) / progressEvent.total
                  ) - 1;
              }).bind(this),
            }
          )
          .then((res) => {
            if (res.status == 200) {
              this.myFile.isUploaded = true;
              this.myFile.uploadPercentage = 100;
              this.myFile.striped = false;
              this.myFile.variant = "success";
              this.myFile.uploadButDisable = false;
              // this.uploadedFiles = res.data;
              this.toast("عکس با موفقیت ویرایش گردید.", "success");
              this.addImageDialog = false;

              this.uploading = false;
              this.title = "";
              this.getImages();
            }
          })
          .catch((err) => {
            console.log(err);
            this.toast(err.response.data, "error");
            this.uploadedFiles = {};
            this.additionalFiles.contract = {};
            this.myFile.uploadPercentage = 0;
          });
      }
    },
    dragover(event) {
      event.preventDefault();
      // Add some visual fluff to show the user can drop its files
      // if (!event.currentTarget.classList.contains("bg-green-300")) {
      //   event.currentTarget.classList.remove("bg-gray-100");
      //   event.currentTarget.classList.add("bg-green-300");
      // }
    },
    dragleave(event) {
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
    },
    drop(event) {
      //event.preventDefault();
      //this.file = event.dataTransfer.files;
      //this.myUpload(this.file);
      // Clean up
      // event.currentTarget.classList.add("bg-gray-100");
      // event.currentTarget.classList.remove("bg-green-300");
      event.preventDefault();
      this.file = event.dataTransfer.files;
      if (Array.from(this.file).length) {
        Array.from(this.file).forEach((file) => {
          this.myUpload(file);
        });
      }
    },
    showBig(item) {
      this.selected = item;
      this.showImage = true;
    },
  },
  computed: {
    computedImage() {
      let filtered;
      filtered = this.images.filter((x) => x.title.includes(this.filter));
      return filtered;
    },
  },
  mounted() {
    if (window.screen.width < 850) {
      this.deviceType = "mobile";
    } else {
      if (document.body.clientWidth < 850) {
        this.deviceType = "mobile";
      } else {
        this.deviceType = "desktop";
      }
    }
    this.role = localStorage.getItem("role");
    this.getImages();
  },
};
</script>
<style lang="scss">
.modal-card {
  border-radius: 10px !important;
  img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .textField-box {
    .v-text-field .v-input__slot,
    .v-text-field fieldset {
      border-radius: 6px !important;
      border-color: #93329e !important;
    }
    .v-input__slot {
      min-height: 48px !important;
      margin-bottom: 25px;
      input {
        color: #656a81 !important;
      }
      .v-text-field__suffix {
        color: #656a81 !important;
      }
    }
  }
  .gallery-imageBox {
    img {
      width: 300px;
      height: 100%;
    }
  }
  .textField-box2 {
    .v-text-field__details {
      display: none;
    }
    .v-text-field .v-input__slot,
    .v-text-field fieldset {
      border-radius: 6px !important;
      border-color: #068d9d !important;
    }
    .v-input__slot {
      min-height: 48px !important;
      margin-bottom: 25px;
      input {
        color: #656a81 !important;
      }
      .v-text-field__suffix {
        color: #656a81 !important;
      }
    }
  }
}
</style>
